import { render } from "./VabSubmenu.vue?vue&type=template&id=0fe38f00"
import script from "./VabSubmenu.vue?vue&type=script&lang=js"
export * from "./VabSubmenu.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/vab/components/VabMenu/components/VabSubmenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0fe38f00"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0fe38f00', __exports__)) {
    console.log('reload')
    api.reload('0fe38f00', __exports__)
  }
  
  module.hot.accept("./VabSubmenu.vue?vue&type=template&id=0fe38f00", () => {
    console.log('re-render')
    api.rerender('0fe38f00', render)
  })

}


export default __exports__